import { OffersMarquee } from "@/components/OffersMarquee";
import { Reveal } from "@/components/Reveal";
import { pricing } from "@/components/OfferCard";
import { getOffer } from "@/services/offers";


const PEOPLE = [
  ["Camille", "@camille.voyage"], ["Julien", "@julien_lb"], ["Sophie", "@sophie.m"], ["Thomas", "@tom.travels"],
  ["Léa", "@lea.ailleurs"], ["Nicolas", "@nico.dlr"], ["Manon", "@manon.horizon"], ["Antoine", "@antoine.vf"], ["Chloé", "@chloe.escapes"],
];

const TRIPS = [
  { id: "tokyo", offer: "cdg-hnd", city: "Tokyo, Japon", image: "/images/tokyo.jpg" },
  { id: "bali", offer: "cdg-dps", city: "Bali, Indonésie", image: "/images/bali.jpg" },
  { id: "rio", offer: "cdg-gig", city: "Rio de Janeiro, Brésil", image: "/images/rio.jpg" },
  { id: "new-york", offer: "cdg-jfk", city: "New York, États-Unis", image: "/images/new-york.jpg" },
  { id: "cancun", offer: "cdg-cun", city: "Cancún, Mexique", image: "/images/cancun.jpg" },
  { id: "bangkok", offer: "cdg-bkk", city: "Bangkok, Thaïlande", image: "/images/bangkok.jpg" },
  { id: "dubai", offer: "cdg-dxb", city: "Dubaï, Émirats arabes unis", image: "/images/dubai.jpg" },
  { id: "mexico", offer: "cdg-mex", city: "Mexico, Mexique", image: "/images/mexico.jpg" },
  { id: "miami", offer: "cdg-mia", city: "Miami, États-Unis", image: "/images/miami.jpg" },
].map((t, i) => {
  const o = getOffer(t.offer);
  const [name, handle] = PEOPLE[i];
  return { ...t, name, handle, saving: pricing(o.price, o.saving).saving };
});

const TripCard = ({ trip, testId }) => (
  <article
    data-testid={testId}
    className="relative h-[360px] w-[270px] shrink-0 select-none overflow-hidden rounded-[28px] bg-navy-deep shadow-[0_20px_50px_-20px_rgba(5,10,30,0.5)] sm:h-[420px] sm:w-[320px]"
  >
    <img src={trip.image} alt={trip.city} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/40 to-transparent" />
    <span className="absolute right-4 top-4 rounded-full bg-navy-deep/85 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-ivory/80 backdrop-blur">
      Économisé <span className="ml-1 text-sm normal-case text-gold">{trip.saving}</span>
    </span>
    <div className="absolute inset-x-0 bottom-0 p-5">
      <p className="font-display text-xl text-ivory">{trip.city}</p>
      <div className="mt-4 flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-full border border-gold/50 bg-navy font-display text-sm text-gold">{trip.name[0]}</span>
        <div className="leading-tight">
          <p className="text-sm font-medium text-ivory">{trip.name}</p>
          <p className="text-xs text-ivory/60">{trip.handle}</p>
        </div>
      </div>
    </div>
  </article>
);

const ROW_A = TRIPS.slice(0, 5);
const ROW_B = TRIPS.slice(4).concat(TRIPS.slice(0, 1));

const Row = ({ trips, speed, testId }) => (
  <OffersMarquee
    offers={trips}
    speed={speed}
    testId={testId}
    renderItem={(t, i, id) => <TripCard key={`${t.id}-${i}`} trip={t} testId={id && `${testId}-card-${id}`} />}
  />
);

export const MemberTrips = () => (
  <section data-testid="member-trips-section" className="bg-ivory pb-16 pt-20 sm:pb-24 sm:pt-28">
    <Reveal className="mx-auto max-w-3xl px-5 text-center">
      <p className="eyebrow text-gold-deep">Ils ont voyagé en Business</p>
      <h2 className="mt-4 font-display text-4xl leading-tight text-navy sm:text-5xl">Nos membres partagent leurs voyages</h2>
      <p data-testid="member-trips-example-note" className="mt-4 text-xs text-navy/50">Économies données à titre d'exemple.</p>
    </Reveal>
    <div className="mt-10 space-y-2 sm:mt-14">
      <Row trips={ROW_A} speed={0.03} testId="member-trips-row-1" />
      <Row trips={ROW_B} speed={-0.03} testId="member-trips-row-2" />
    </div>
  </section>
);
